import axios from 'axios';
import i18next from 'i18next';

import downloadFile from './downloadFile';

export default (archive, loadingContext, name) => async (dispatch) => {
    loadingContext.openLoading(i18next.t('Download file').concat('...'));
    await axios({
        url: archive,
        method: 'get',
        responseType: 'blob',
    })
        .then((response) => {
            loadingContext.closeLoading();
            const url = window.URL.createObjectURL(new Blob([response.data]));
            dispatch(downloadFile(name, url, 'pdf'));
        })
        .catch(() => loadingContext.closeLoading());
};
